import { View, tokens } from '@sapphire-react/core';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  height?: string;
  borderRadius?: string | number;
  showRightBorderRadius?: boolean;
};

export function FormLayout({
  children,
  borderRadius = tokens.size.radiusSm.value,
  height = 'auto',
  showRightBorderRadius = true,
}: Props) {

  return (
    <View
      width={'100%'}
      paddingLeft={{ base: 12, sm: 16, md: 32 }}
      paddingRight={{ base: 12, sm: 16, md: 32 }}
      paddingTop={{ base: 24, md: 32 }}
      paddingBottom={{ base: 24, md: 32 }}
      flexDirection={'column'}
      backgroundColor={tokens.color.backgroundNeutralSubtle.value}
      borderBottomRightRadius={showRightBorderRadius ? borderRadius : 0}
      borderTopRightRadius={showRightBorderRadius ? borderRadius : 0}
      borderBottomLeftRadius={borderRadius}
      borderTopLeftRadius={borderRadius}
      height={height}
      UNSAFE_style={{ boxSizing: 'border-box', minWidth: 0 }}
    >
      {children}
    </View>
  );
}
